module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("3")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RNOLD")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S HOME IS")]), _vm._v(", by any measure, a grand place. The building is white with bold pillars in front and a circular drive, has a large, well-kept garden complete with a topiary and several fountains, and you reach Arnold’s apartment through a lofty entrance hall hung with portraits and a wide marble stairway. The apartment is all Arnold’s, of course, the "), _c('em', [_vm._v("faux")]), _vm._v(" Edwardian grandeur and suitably worn Persian carpets, but another, not altogether congruent presence is there too. My mother has brought to her new home my late father’s collection of Africana, and to me, at least, this almost restores a balance, prevents the place from being entirely Arnold’s domain. My father’s collection is embedded in the public rooms without much attention to ownership, to the origin of things, and over the years the house’s contents might have come to seem to others to fit together, to be part of a single seamless construct, like a marriage, perhaps, but that was never so for me. I was always acutely aware of what was Arnold’s and what was once my father’s.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("It is unsettling, to both Bridget and to me, but especially to me now that my mother is so weak, to watch Arnold act as if he has become, by default, the custodian of everything, including, of course, of my mother. She has lost her independence, and because she is his wife, like it or not, and we are in his home, there is a fine line to tread. Most of the time Arnold does not seem to care what we do, but if he did care, if he were to challenge us on something, it is not clear ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("whose word would govern. My mother is no longer walking about the house, her perfume filling its rooms, arranging the flowers, answering the phone, and a balance has quite tipped. Arnold’s presence, his old man’s scent, is everywhere, and everything in the house has become, if not inaccessible, somehow unfriendly.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This is true of little things too, things like plates and the knives, even the television set. We touch Arnold’s buttons, when we have to, with an edge of distaste.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71e17afb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Chapter03.vue
// module id = 90
// module chunks = 0